import { TextDivider, type TextDividerProps } from './TextDivider';

interface TextDividerSimpleProps {
  text: string;
}

const TEXT_DIVIDER_SIMPLE_PROPS = {
  textProps: {
    color: 'colors.gray.080',
    fontSize: 'fontSizeSm',
    weight: 'fontWeightNormal',
  },
  dividerProps: { color: 'colors.gray.000' },
} as const satisfies Omit<TextDividerProps, 'text'>;

/**
 * @deprecated Use SectionTitle instead.
 * A lightweight version of TextDivider with subdued default styling (adding modes over time if needed).
 * Uses lighter colors, smaller font size, and normal weight for a more subtle appearance.
 */
export function TextDividerSimple({ text }: TextDividerSimpleProps) {
  return <TextDivider text={text} {...TEXT_DIVIDER_SIMPLE_PROPS} />;
}
